import { render, staticRenderFns } from "./propertyAssetStatisticSummary.vue?vue&type=template&id=661fa96e&scoped=true&"
import script from "./propertyAssetStatisticSummary.vue?vue&type=script&lang=js&"
export * from "./propertyAssetStatisticSummary.vue?vue&type=script&lang=js&"
import style0 from "./propertyAssetStatisticSummary.vue?vue&type=style&index=0&id=661fa96e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661fa96e",
  null
  
)

export default component.exports